<ng-template #progressSpinnerRef>
	<mat-progress-spinner id="overlaySpinnerId" [color]="color" [diameter]="diameter" [mode]="mode" [strokeWidth]="strokeWidth" [value]="value">
	</mat-progress-spinner>
	<span id="overlaySpinnerStatusId" class="visually-hidden">{{ !!(isLoading$ | async) }}</span>
</ng-template>
